import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Plus, GripVertical, Edit2 } from 'lucide-react';
const MENU_TABS = [{
  label: 'Products',
  path: ''
}, {
  label: 'Categories',
  path: 'categories'
}, {
  label: 'Modifiers',
  path: 'modifiers'
}, {
  label: 'Combos',
  path: 'combos'
}, {
  label: 'Stock',
  path: 'stock'
}, {
  label: 'Promotions',
  path: 'promotions'
}, {
  label: 'Performance',
  path: 'performance'
}];
const CATEGORIES = [{
  name: 'Burgeri',
  icon: '🍔',
  items: 42,
  revenue: '2.4M RSD',
  active: true
}, {
  name: 'Palačinke',
  icon: '🥞',
  items: 35,
  revenue: '890K RSD',
  active: true
}, {
  name: 'Salate',
  icon: '🥗',
  items: 12,
  revenue: '320K RSD',
  active: true
}, {
  name: 'Giros',
  icon: '🌯',
  items: 8,
  revenue: '210K RSD',
  active: true
}, {
  name: 'Sides',
  icon: '🍟',
  items: 28,
  revenue: '1.8M RSD',
  active: true
}, {
  name: 'Drinks',
  icon: '🥤',
  items: 45,
  revenue: '580K RSD',
  active: true
}, {
  name: 'Bakery',
  icon: '🧁',
  items: 18,
  revenue: '190K RSD',
  active: true
}, {
  name: 'Desserts',
  icon: '🍰',
  items: 15,
  revenue: '145K RSD',
  active: false
}];
export function Categories() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1247">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1248">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1249">Categories</h1>
        <Button icon={<Plus size={16} data-id="element-1251" />} data-id="element-1250">Add Category</Button>
      </div>

      <TabNavigation tabs={MENU_TABS} basePath="/menu" data-id="element-1252" />

      <Card noPadding data-id="element-1253">
        <div className="divide-y divide-white/5" data-id="element-1254">
          {CATEGORIES.map((cat, i) => <div key={i} className="p-4 flex items-center gap-4 hover:bg-white/5 transition-colors group" data-id="element-1255">
              <GripVertical className="text-text-muted cursor-grab hover:text-text-primary" size={20} data-id="element-1256" />
              <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-xl" data-id="element-1257">
                {cat.icon}
              </div>
              <div className="flex-1 min-w-0" data-id="element-1258">
                <h3 className="font-bold text-lg" data-id="element-1259">{cat.name}</h3>
                <div className="text-sm text-text-secondary" data-id="element-1260">
                  {cat.items} items
                </div>
              </div>
              <div className="text-right mr-8" data-id="element-1261">
                <div className="font-mono font-medium" data-id="element-1262">{cat.revenue}</div>
                <div className="text-xs text-text-secondary" data-id="element-1263">Revenue</div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1264">
                <span className={`text-xs font-bold px-2 py-1 rounded-full ${cat.active ? 'bg-accent-success/10 text-accent-success' : 'bg-white/10 text-text-muted'}`} data-id="element-1265">
                  {cat.active ? '● Active' : '○ Inactive'}
                </span>
                <Button size="sm" variant="secondary" icon={<Edit2 size={14} data-id="element-1267" />} data-id="element-1266">
                  Edit
                </Button>
              </div>
            </div>)}
        </div>
      </Card>
    </div>;
}